export default {
  moduleName: "requestQueue",
  namespaced: true,

  state: () => ({
    controllers: [],
  }),
  getters: {
    controllers(state) {
      return state.controllers;
    },
  },
  mutations: {
    add(state, controller) {
      state.controllers.push(controller);
    },
    abortAll(state) {
      state.controllers.forEach((c) => {
        c.cancel();
      });
      state.controllers = [];
    },
  },
  actions: {
    add({ commit }, controller) {
      commit("add", controller);
    },
    abortAll({ commit }) {
      commit("abortAll");
    },
  },
};
